<template>
  <div class="yunxiao teacher class-add-students">
    <search-filter-new
      :items="['search', 'filter']"
      :placeholder="'请输入姓名/手机号后4位'"
      @onSearch="params.query = $event"
      @onFilter="openFilter"
      :hasFilter="hasFilter"
    />
    <div class="tips-nav">
      <div class="tips-left">
        <div>可上</div>
        <div class="ellipsis">{{ classInfo.curriculumName }}</div>
        <div>的学员</div>
      </div>
      <van-checkbox class="tips-right" icon-size="16px" v-model="params.noClass">
        <span :style="!params.noClass ? { color: 'var(--g7)' } : {}">仅看未入班</span>
      </van-checkbox>
    </div>
    <vx-list
      class="student-list-nav"
      enable
      :api="$api.findClassAddStudent"
      :params="translatedParams"
      @load="onLoad"
      v-if="classInfosLoaded"
    >
      <div class="student-item-wrapper">
        <div class="student-item" v-for="item of list" :key="item.id" @click="clickHandler(item)">
          <div class="item-checked">
            <van-icon v-if="choosedIds.includes(item.id)" name="checked" size="var(--fs-ex1)" color="var(--c1)" />
            <van-icon v-else name="circle" size="var(--fs-ex1)" color="var(--g5)" />
          </div>
          <div class="photo-nav" v-if="!item.photo">
            {{ item.name && item.name.substr(-2) }}
          </div>
          <img class="photo-nav" v-else :src="item.photo.url" />
          <div class="desc van-ellipsis">
            <div class="lin1">
              <div class="name van-ellipsis">
                {{ item.name }}
              </div>
              <van-tag plain type="primary" color="var(--g5)" style="margin-left: 4px;" v-if="item.courseRelation === 0">不再上课</van-tag>
            </div>
            <div class="info flex-between">
              <span v-if="item.noClass">未入班</span>
              <span v-else>
                在读班级：
                <span>{{ getClassList(item) }}</span>
              </span>
              <span class="sus-date" v-if="item.status == 7">{{item.suspendCourseDate | formatDatetime('yyyy-MM-dd')}} 停课</span>
            </div>
          </div>
        </div>
      </div>

      <empty-page :show="list.length === 0 && !loading" tips="没有找到学员~" />
    </vx-list>
    <div class="footer">
      <div class="choosed-status">
        <van-checkbox
          v-model="allChecked"
          icon-size="var(--fs-ex1)"
        />
        <div class="checked-nav" :class="{ 'all-checked': allChecked }">
          <div class="check-icon flex-center">全选</div>
          <div class="check-desc" @click.stop="showSelect">查看已选</div>
        </div>
      </div>
      <van-button
        class="ccbtn"
        square
        round
        block
        @click="$router.back()"
        style="margin-right: 8px; padding: 0 12px"
      >
        取消
      </van-button>
      <van-button
        class="cnbtn"
        square
        round
        block
        type="primary"
        loading-text="保存中..."
        :loading="isSubmit"
        @click="confirmAddStudents"
        style="white-space: nowrap; padding: 0 12px"
      >
        确认
      </van-button>
    </div>
    <van-popup
      :safe-area-inset-bottom="true"
      position="bottom"
      round
      v-model="chooseDatePopup"
      closeable
    >
      <div class="popup-body">
        <div class="popup-title">请选择学员入班日期</div>
        <div
          class="van-hairline--bottom"
          style="padding-bottom: calc(var(--gap) * 14); margin: 0 calc(var(--gap) * 16)"
        >
          学员将加入入班日期后的班级排课
        </div>
        <van-cell @click="chooseDate">
          <template #title>
            <div class="cell-title">入班日期</div>
          </template>
          <div class="cell-value" :class="{ placeholder: !inDate }">
            <span>
              {{ inDate ? inDate : '请选择' }}
            </span>
            <van-icon name="arrow"></van-icon>
          </div>
        </van-cell>
        <div style="background-color: var(--g1); height: calc(var(--w) * 11)"></div>
      </div>
      <div class="popup-footer">
        <van-button type="primary" block square round @click="confirmInDate">确定</van-button>
      </div>
    </van-popup>
    <van-action-sheet v-model="as1" :round="false" get-container="body">
      <div class="as1wrap">
        <div class="head">
          <div class="til">已选({{ choosedList.length }})</div>
          <div class="clearbtn" @click="delAll">清空</div>
        </div>
        <div class="as1body">
          <template v-for="(seitem, index) in choosedList">
            <slot :item="seitem" :index="index">
              <div class="line van-hairline--bottom" :key="seitem['id']">
                <div class="l">
                  <div class="name van-ellipsis">
                    <slot name="cont" :item="seitem" :index="index">
                      {{ seitem['name'] }}
                    </slot>
                  </div>
                </div>
                <div class="r">
                  <van-icon name="clear" color="var(--g6)" @click="del(index)" />
                </div>
              </div>
            </slot>
          </template>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import emptyPage from '@teacher/components/empty-page.vue';

export default {
  name: 'classAddMoreStudents',
  components: {
    SearchFilterNew,
    emptyPage,
  },

  data() {
    return {
      pageTitle: '添加学员',
      params: {
        noClass: true,
        curriculumId: '',
        query: '',
        currentClassId: this.$vxRoute.params.classId,
        sexList: [],
        ageFrom: '',
        ageTo: '',
        status: [1],
        courseRelations: [1],
        cardTypeList: [],
        chargeTypeList: [],
      },
      // 学员列表
      list: [],
      total: 0,
      loading: true,
      classInfo: {},
      classInfosLoaded: false,
      isSubmit: false,
      chooseDatePopup: false,
      inDate: '',
      choosedList: [],
      choosedIds: [],
      as1: false
    };
  },
  computed: {
    hasFilter: function () {
      let { ageFrom, ageTo, sexList, query, status, courseRelations } = this.params;
      if (
        query.length ||
        ageTo.length ||
        ageFrom.length ||
        sexList.length ||
        status.length ||
        courseRelations.length
      ) {
        return true;
      }
      return false;
    },
    ids() {
      return this.choosedList.map(({ id }) => id);
    },
    translatedParams() {
      let params = { ...this.params };
      if (!params.noClass) {
        params.noClass = null;
      }
      return params;
    },
    allChecked: {
      get() {
        return this.list.length == this.choosedList.length;
      },
      set(val) {
        if (val) {
          this.choosedIds = this.list.map(item => item.id);
          this.choosedList = this.list.map(item => item);
        } else {
          this.choosedIds = [];
          this.choosedList = []
        }
      },
    },
  },
  methods: {
    async getclassInfo() {
      let res = await this.$api.getClassInfoVo({
        classId: this.$vxRoute.params.classId,
      });

      this.classInfo = res.data;
      this.initParams();
    },
    getClassList({ classList }) {
      let classStr = '-';
      if (classList && classList.length) {
        classStr = classList.map(v => v.className || '-').join('、');
      }
      return classStr;
    },
    initParams() {
      let { campusId, curriculumId } = this.classInfo;
      Object.assign(this.params, { curriculumId, campusId });
    },
    // 学生列表数据加载结束
    onLoad(list, res) {
      this.list = list;
      this.total = list.length;
      this.loading = false;
      res.code === 200 && this.$toast.clear();
    },
    // 打开筛选
    async openFilter() {
      let res = await app.x3.side.xsStudentMoreFiltrate({
        params: this.params,
        config: {
          enableIntentionStatus: false,
          enableStudentStatus: false,
          hideCourse: true, // 隐藏“课程”筛选项
          hideClass: true, // 隐藏“班级”筛选项
          hideFollowTeacherStatus: true, // 隐藏“跟进人状态”筛选项
          hideComeform: true, // 隐藏“招生来源”筛选项
          hideStudentStatus: false, // 隐藏“学员状态”筛选项
          hideInvalStu: true,
          hideCardType: false,
          hideChargeType: false,
          enableStudentStatusIds: [1, 6, 7],
          hideStudentCourseRelations: false,
          hideStuClassStatus: true, // 隐藏“在班情况”筛选项
          hideActiveStatus: true, // 隐藏“绑定家长端账号”筛选项
          hideFaceStatus: true, // 隐藏“脸部信息”筛选项
          hideCreateDate: true, // 隐藏“创建日期”筛选项
        },
      });
      let {
        ageFrom = '',
        ageTo = '',
        sexList = [],
        status = [],
        courseRelations = [],
        cardTypeList = [],
        chargeTypeList = [],
      } = res.params || {};
      this.params = Object.assign(this.params, {
        ageFrom,
        ageTo,
        sexList,
        status,
        courseRelations,
        cardTypeList,
        chargeTypeList,
      });
    },
    chooseDate(idx, changeInDate) {
      app.x3.picker
        .datetime({
          type: 'date',
          'min-date': new Date('2020/01/01'),
          'max-date': new Date(),
          value: this.inDate ? new Date(this.inDate.replace(/\-/g, '/')) : new Date(),
        })
        .then(res => {
          this.inDate = app.tool.date.filterDate(res);
        });
    },
    clickHandler(item) {
      if (this.choosedIds.includes(item.id)) {
        let idx = this.choosedIds.indexOf(item.id);
        this.choosedIds.splice(idx, 1);
        this.choosedList.splice(idx, 1);
      } else {
        this.choosedIds.push(item.id);
        this.choosedList.push(item);
      }
      console.log(this.choosedIds);
      console.log(this.choosedList);
    },
    confirmAddStudents() {
      if (!this.choosedIds.length) {
        vant.Toast('请选择学员');
        return false;
      }
      this.chooseDatePopup = true;
      this.inDate = app.tool.date.filterDate(new Date());
    },
    confirmInDate() {
      if (!this.inDate) {
        vant.Toast('请选择日期');
        return false;
      }
      this.confirm(0);
    },
    // 提交添加更多学员
    async confirm(oversold) {
      this.showLoading();
      let res = await this.$api.intoClass({
        campusId: this.params.campusId,
        classId: this.classInfo.id,
        studentIds: this.choosedIds,
        curriculumId: this.classInfo.curriculumId,
        oversold: oversold || 0,
        inDate: this.inDate,
      });
      this.$toast.clear();
      if (res.code === 200) {
        vant.Toast.success('操作成功');
        app.vue.$emit('refresh-classStudentList');
        this.$router.back();
        return false;
      }

      if (res.code == 830000024) {
        vant.Dialog.alert({
          title: '学员入班失败',
          allowHtml: true,
          message: `以下学员在所选入班日期已在班或在所选日期后存在入班记录，无法入班。请前往学员详情查看学员出入班记录。<br><span style="color: var(--g8);">${res.msg}</span>`,
          confirmButtonText: '确认',
          messageAlign: 'left',
        });
        return false;
      }

      if (res.code == 790000001 && !oversold) {
        vant.Dialog.confirm({
          title: '提示',
          message: '班级学员已满，是否确认继续添加学员',
        })
          .then(() => this.confirm(1))
          .catch(() => {
            console.log('取消添加学员');
          });
        return false;
      }
      if (res.code > 60000) this.$toast.fail(res.msg);
    },
    // 查看已选
    showSelect() {
      console.log('this.choosedList',this.choosedList)
      if (this.choosedList.length > 0) {
        this.as1 = true;
      } else {
        vant.Toast('请至少先选择一个');
      }
    },
    // 清空全部已选
    delAll() {
      this.as1 = false;
      this.choosedIds.splice(0);
      this.choosedList.splice(0);
    },
    // 移除某个
    del(index) {
      this.choosedIds.splice(index, 1);
      this.choosedList.splice(index, 1);
      if (this.choosedList.length == 0) {
        this.as1 = false;
      }
    },
  },

  async created() {
    this.showLoading();
    try {
      await this.getclassInfo();
      this.classInfosLoaded = true;
      this.$toast.clear();
    } catch (err) {
      console.log(err);
    }
  },
};
</script>

<style lang="scss" scoped>
.yunxiao.teacher.class-add-students {
  display: flex;
  flex-direction: column;
  .tips-nav {
    position: relative;
    padding: calc(var(--gap) * 12) calc(var(--fs-md) * 8) calc(var(--gap) * 12)
      calc(var(--gap) * 12);
    color: var(--g6);
    .tips-left {
      display: flex;
      width: 100%;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);
      > div.ellipsis {
        max-width: 100%;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .tips-right {
      position: absolute;
      top: calc(var(--gap) * 12);
      right: calc(var(--gap) * 12);
      justify-content: flex-end;
      white-space: nowrap;
      width: calc(var(--fs-md) * 7);
    }
    ::v-deep.van-checkbox__label {
      margin-left: calc(var(--gap) * 4);
    }
  }
  .student-list-nav {
    flex: 1;
    .student-item {
      position: relative;
      display: flex;
      align-items: center;
      height: calc(44px + 2 * calc(var(--gap) * 12));
      padding: 0 0 0 calc(var(--gap) * 50);
      width: 100%;
      background-color: var(--white);
      .photo-nav {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        font-size: var(--fs-lg);
        line-height: var(--lh-lg);
        color: var(--white);
        background-color: var(--c1);
        border-radius: 50%;
        border: unset;
        outline: unset;
        margin-right: calc(var(--gap) * 8);
        flex-shrink: 0;
      }
      .desc {
        padding-right: calc(var(--gap) * 16);
        flex: 1;
        border-bottom: 1px solid var(--g3);
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow: hidden;
        .lin1 {
          display: flex;
          justify-content: space-between;
          .name {
            font-size: var(--fs-lg);
            line-height: var(--lh-lg);
            font-weight: var(--bold);
            color: var(--g8);
          }
        }
        .info {
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
          margin-top: 2px;
          .sus-date {
            flex-shrink: 0;
            color: var(--c4);
            font-size:var(--fs-sm);
            line-height:var(--lh-sm);
          }
        }
      }
      &:last-child .desc {
        border-bottom: unset;
      }
      .item-checked {
        position: absolute;
        left: calc(var(--gap) * 16);
        top: 50%;
        width: calc(var(--w) * 18);
        height: calc(var(--w) * 18);
        transform: translateY(-50%);
      }
      // .buzaiicon {
      //   font-size: 44px;
      //   color: var(--g5);
      //   position: absolute;
      //   right: 10px;
      //   top: 10px;
      //   transform: rotate(30deg);
      // }
    }
    .van-empty__description {
      padding: 0 calc(var(--gap) * 32);
    }
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }
    .ccbtn {
      flex: 2;
    }
    .cnbtn {
      flex: 5;
    }
    .choosed-status {
      flex: 1;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);
      display: flex;
      align-items: flex-start;
      .checked-nav {
        margin: 0 calc(var(--gap) * 16) 0  calc(var(--gap) * 8);
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        color: var(--g6);
        .check-icon {
          .van-checkbox {
            margin-right: calc(var(--gap) * 8);
          }
        }
        .check-desc {
          color: var(--tlc);
        }
        > div {
          margin-right: calc(var(--gap) * 4);
        }
        &.all-checked {
          color: var(--g8);
        }
      }
    }
  }
}
.popup-body {
  text-align: center;
  color: var(--g6);
  .popup-title {
    color: var(--g8);
    margin: calc(var(--gap) * 13) 0 calc(var(--gap) * 4);
    font-size: var(--fs-lg);
    line-height: var(--lh-lg);
    font-weight: var(--bold);
  }
  .cell-title {
    text-align: left;
    color: var(--g7);
    font-size: var(--fs-md);
    line-height: var(--lh-md);
  }
  .cell-value {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &:not(.placeholder) {
      color: var(--g7);
    }
    i {
      margin-left: calc(var(--gap) * 8);
    }
  }
}
.popup-footer {
  background-color: #fff;
  padding: calc(var(--gap) * 4) calc(var(--gap) * 16);
}
.as1wrap {
  .head {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .clearbtn {
      position: absolute;
      right: calc(var(--gap) * 16);
      top: 50%;
      color: var(--tlc);
      font-size: var(--fs-md);
      line-height: var(--lh-md);
      padding: 6px;
      transform: translate3d(0, -50%, 0);
      margin-right: -6px;
    }
  }
  .as1body {
    min-height: 200px;
    max-height: 70vh;
    overflow: auto;
    .line {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: calc(var(--gap) * 8) calc(var(--gap) * 16);
      .l {
        overflow: hidden;
        .name {
          font-size: var(--fs-md);
          line-height: var(--lh-md);
          color: var(--g8);
        }
        .desc {
          margin-top: calc(var(--gap) * 4);
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--g6);
        }
      }
      .r {
        line-height: 0;
        padding: 8px;
        margin-right: -8px;
      }
    }
  }
}
</style>